import styled, { css } from 'styled-components';
import { medias } from '@/utils/sizes';
import { generateClampFromMax, generateClampFromMinMax } from '@/utils/styling';
import { Button } from '@/components/atoms/Button/Button.styled';
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink.styled';

export const Header = styled.header`
  --header-height: ${generateClampFromMinMax(48, 107)};

  height: var(--header-height);
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  background: var(--bg-page);
  z-index: 10;
  transition:
    background-color var(--tr-base),
    border-color var(--tr-base);

  &:has(+ .presentation-page) {
    .header-menu,
    .burger-button {
      display: none;
    }
  }

  .two-col-container {
    padding-top: 0;
  }

  .logo-container-link img {
    transition: filter var(--tr-base);
  }

  .component-container {
    z-index: 10;
    margin-bottom: 0;
  }

  .link-active {
    position: relative;
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: -10px;
      transform: translateY(-50%);
      width: 4px;
      height: 4px;
      border-radius: 10px;
      background-color: currentColor;
      opacity: 1;
      transition: opacity var(--tr-base);

      ${medias.max.tablet} {
        background-color: var(--c-white);
        width: 6px;
        height: 6px;
        left: -11px;
      }
    }

    &:hover {
      color: var(--c-font-primary);
    }
  }

  ${medias.max.tablet} {
    border-bottom: 1px solid var(--c-border);
    border-color: var(--c-border);

    .two-col-container {
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .burger-button {
    display: none;
    height: 42px;
    padding-left: 10px;
    align-items: center;

    ${medias.max.tablet} {
      display: block;
    }
  }

  .burger-button svg {
    transition: filter 0.2s;
  }

  &[data-is-scrolltop='true'] {
    &[data-is-homepage='true'] {
      background-color: transparent;
      border-color: transparent;
      background-color: transparent;

      img,
      .burger-button svg {
        filter: invert(1);
      }

      button,
      a,
      span {
        color: white;
      }

      ${medias.max.tablet} {
        border-color: transparent;
      }
    }

    &[data-is-homepage='false'] {
      // TODO: correct here page transition effect
    }
  }

  &[data-is-mobile-open='true'] {
    ${medias.max.tablet} {
      border-color: transparent;

      img,
      svg {
        filter: invert(1);
      }

      .burger-button svg {
        transition: filter 0.1s var(--tr-base);
      }
    }
  }

  &[data-is-mobile-open='false'] {
    nav[data-is-mobile='true'] {
      pointer-events: none;
      opacity: 0;
    }
  }
`;

export const HeaderContentDesktop = styled.div.withConfig({})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  ${medias.max.tablet} {
    display: none;
  }
`;

export const BgMobileMenu = styled.div`
  position: absolute;
  top: calc(var(--header-height) * -1);
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: var(--bg-black);
  transform: scaleX(0);
  transform-origin: left;
  transition: background-color var(--tr-base) ease-in-out;
`;

export const ItemsNav = styled.nav`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  transition: opacity 2s;

  &.presentation-menu {
    width: auto;
    margin-left: auto;

    .link {
      padding: 10px 0;
    }

    .link:before {
      display: none !important;
    }
  }

  > *:not(:last-child) {
    margin-right: ${generateClampFromMax(150)};
  }
`;

export const HeaderContentMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})<{
  isOpen: boolean;
}>`
  ${medias.min.desktopSm} {
    display: none;
  }

  pointer-events: none;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: calc(100vh - var(--header-height));
  height: calc(100dvh - var(--header-height));
  width: 100%;
  top: var(--header-height);
  left: 0;

  ${ItemsNav} {
    pointer-events: none;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    padding: 0 var(--page-pd-mobile-tablet);
    margin-top: 10vh;
    opacity: 1;
    transition: opacity 10s;

    ${CustomLink},
    ${Button} {
      font-size: var(--fs-2xl);
      margin-bottom: var(--spacing-component-inner-lg);
      color: var(--c-white);
      font-family: var(--ff-helvetica-light);

      ${medias.max.mobile} {
        font-size: var(--fs-4xl);
      }
    }

    &:last-child {
      flex-direction: row;
      justify-content: space-between;
      align-items: end;

      ${CustomLink},
      ${Button} {
        font-size: var(--fs-xl);
      }
    }
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      pointer-events: all;

      /* ${BgMobileMenu} {
        transform: scaleX(1);
      } */

      ${ItemsNav} {
        /* opacity: 1; */
        pointer-events: all;
      }
    `}
`;
